"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OperationSummary = void 0;
const utils_1 = require("../utils");
exports.OperationSummary = () => {
    return {
        Operation(operation, ctx) {
            utils_1.validateDefinedAndNonEmpty('summary', operation, ctx);
        },
    };
};
